enum SSOProvider {
	Microsoft = "MICROSOFT",
	Google = "GOOGLE"
}

export default SSOProvider;